export default __webpack_public_path__ + "static/poster-894d9f612647a231a6127f08e525cfcc.png";